// extracted by mini-css-extract-plugin
export default {"succ_d":"Success_succ_d__YTJlV","succ":"Success_succ__WUmi7","succ_l":"Success_succ_l__t9tb0"};